import { isCuil, isValidCuil, isValidEmail } from 'utils/functions/validations'

const settingValidate = {
  rol: {
    required: 'Campo requerido',
  },
  nacionalidad: {
    required: 'Campo requerido',
  },
  tipoDocumento: {
    required: 'Campo requerido',
  },
  documento: {
    required: 'Campo requerido',
  },
  cuil: {
    required: 'Campo requerido',
    validate: (value: string) => {
      const cuit = value.replace(/-/gi, '')
      return (isValidCuil(cuit) && isCuil(cuit)) || 'Dato no válido'
    },
  },
  email: {
    required: 'Campo requerido',
    validate: (value: string) => isValidEmail(value) || 'Dato no válido',
  },
  nombre: {
    required: 'Campo requerido',
  },
  apellido: {
    required: 'Campo requerido',
  },
  codPais: {
    required: 'Campo requerido',
  },
  codArea: {
    required: 'Campo requerido',
    minLength: {
      value: 2,
      message: 'El formato del teléfono no es válido',
    }
  },
  phoneNumber: {
    required: 'Campo requerido',
    pattern: {
      value: /^[0-9]+$/,
      message: 'Dato no válido',
    }
  },
  user: {
    required: 'Campo requerido'
  },
  password: {
    required: 'Campo requerido'
  },
}

export default settingValidate
